import type { ReUploadConfig } from 'garaje/models/custom-user-document-template';

import ApplicationAdapter from './application';

interface TemplateConfigAttrs {
  reUploadConfig?: ReUploadConfig;
  allowLlmParsing?: boolean;
}

export default class DocumentUploadPageAdapter extends ApplicationAdapter {
  /**
   * Fetch per-page template configurations.
   * GET /document-upload-pages/:id/configurations
   */
  async fetchConfigurations(pageId: string): Promise<unknown> {
    const url = `${this.buildURL('document-upload-page', pageId)}/configurations`;
    return this.ajax(url, 'GET');
  }

  /**
   * Link a template to this page with per-page config overrides.
   * POST /document-upload-pages/:id/add-template
   */
  async addTemplate(pageId: string, templateId: string, attrs: TemplateConfigAttrs): Promise<unknown> {
    const url = `${this.buildURL('document-upload-page', pageId)}/add-template`;
    return this.ajax(url, 'POST', {
      data: {
        data: {
          type: 'user-document-template-configurations',
          attributes: {
            'allow-llm-parsing': attrs.allowLlmParsing ?? false,
            're-upload-config': attrs.reUploadConfig,
          },
          relationships: {
            'user-document-template': {
              data: { type: 'custom-user-document-templates', id: templateId },
            },
          },
        },
      },
    });
  }

  /**
   * Update per-page config for an already-linked template.
   * PATCH /document-upload-pages/:id/update-template
   */
  async updateTemplate(pageId: string, templateId: string, attrs: TemplateConfigAttrs): Promise<unknown> {
    const url = `${this.buildURL('document-upload-page', pageId)}/update-template`;
    return this.ajax(url, 'PATCH', {
      data: {
        data: {
          type: 'user-document-template-configurations',
          attributes: {
            'allow-llm-parsing': attrs.allowLlmParsing ?? false,
            're-upload-config': attrs.reUploadConfig,
          },
          relationships: {
            'user-document-template': {
              data: { type: 'custom-user-document-templates', id: templateId },
            },
          },
        },
      },
    });
  }
}
